import { action, computed, makeObservable, observable } from 'mobx';

export interface StatisticControllerValue {
  tableName: string;
  tableLabel: string;
  data?: any;
}

type StatisticControllerState =
  | { status: 'opened'; value: StatisticControllerValue }
  | { status: 'closed' };

export class StatisticMenuController {
  @observable private _state: StatisticControllerState = {
    status: 'closed',
  };

  constructor() {
    makeObservable<StatisticMenuController>(this);
  }

  @computed get state(): StatisticControllerState {
    return this._state;
  }

  @action open = (value: StatisticControllerValue) => {
    this._state = { status: 'opened', value };
  };

  @action close = () => {
    this._state = { status: 'closed' };
  };
}
